<div>
    <div *ngIf="plotterImageDataUrl; else leafletPlotter" style="position:relative;">
        <button class="btn btn-secondary" 
            style="position:absolute;top:0;right:0;font-size:10px;padding:2px 3px;"
            (click)="rebuild()">
            Rebuild
        </button>
        <img [src]="plotterImageDataUrl" > 
    </div>
    
    <div *ngIf="errorMsg" class="alert alert-danger">
        {{errorMsg}}&nbsp;&nbsp;&nbsp;
        <button class="btn btn-secondary" [disabled]="retryStarting"
        style="position:absolute;top:0;right:0;font-size:10px;padding:2px 3px;"
        (click)="retry()">
            Retry
        </button>
    </div>

    <ng-template #leafletPlotter>
        <div class="busy-overlay-parent" [ngClass]="!plotterImageDataUrl&&!errorMsg?'disabled':''">

            <div *ngIf="!plotterImageDataUrl&&!errorMsg" class="font-weight-bold busy-overlay" style="z-index:1000;">
              <i class="fa fa-spinner fa-spin"></i>&nbsp;
              <span *ngIf="(scoutPathPlotter?.overlayIntializing|async)==true; else notLoadingOverlay">
                Loading overlay '{{scoutPathPlotter.overlay?.jpgName}}'
              </span>
              <ng-template #notLoadingOverlay>
                <span>
                  Converting leaflet map to image...
                </span>
              </ng-template>
            </div>            
            <div *ngIf="!retryStarting" #plotterPanel [ngStyle]="mapStyle">
                <app-scout-path-plotter
                    (mapReady)="onMapReady($event)" 
                    [showZoomControl]="false"
                    [overlay]="overlay"
                    [hideLayersControl]="true"
                    [blockEvents]="true"
                    #scoutPathPlotter></app-scout-path-plotter>
            </div>
        </div>
    </ng-template>
</div>

